import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function mustBeModified(initialValue: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value === initialValue ? { mustBeModified: true } : null;
  };
}
